import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  inject,
} from '@angular/core';
import {
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  PublicClientApplication,
  InteractionType,
  AuthenticationResult,
  Configuration,
} from '@azure/msal-browser';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: environment.msalConfig.clientId,
    authority: environment.msalConfig.authority,
    redirectUri: environment.msalConfig.redirectUri,
    postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export function MSALInstanceFactory() {
  return new PublicClientApplication(MSAL_CONFIG);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.msalConfig.scopes,
    },
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  ((environment.msalConfig as any).protectedResourceMap || []).forEach((entry: any) => {
    protectedResourceMap.set(entry.url, entry.scopes);
  });

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}


export function checkAuthenticationAndRedirect(): void {
  const msalService = inject(MsalService);
  const router = inject(Router);

  msalService.instance
    .handleRedirectPromise()
    .then((authResult: AuthenticationResult | null) => {
      if (authResult && authResult.account) {
        localStorage.setItem('accessToken', authResult.accessToken);
      } else {
        router.navigate(['/login']);
      }
    });
}

export function provideMSAL(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ]);
}
